/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import React, { useState } from 'react';
import {
  chipInputStyle as inputStyle,
  chipInputLabelStyle as labelStyle,
  chipInputChipStyle as chipStyle,
  chipInputRemoveButtonStyle as removeButtonStyle,
} from './chip-input-styles';

interface TagInputProps {
  value: string[];
  onChange: (value: string[]) => void;
  placeholder: string;
  label?: string;
}

export const TagInput: React.FC<TagInputProps> = ({ value, onChange, placeholder, label }) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trimmed = inputValue.trim();
      if (!trimmed || value.includes(trimmed)) return;
      onChange([...value, trimmed]);
      setInputValue('');
    }
  };

  const handleRemove = (item: string) => {
    onChange(value.filter(v => v !== item));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {label && <label style={labelStyle}>{label}</label>}
      <input
        style={inputStyle}
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
      />
      {value.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
          {value.map(item => (
            <span key={item} style={chipStyle}>
              {item}
              <button
                type="button"
                onClick={() => handleRemove(item)}
                aria-label={`Remover ${item}`}
                style={removeButtonStyle}
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
